import { LoginController } from '../../controllers/login-controller'
import { PageMessageService } from '../../services/page-message-service';
import { autoinject, Aurelia } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { Router } from 'aurelia-router';
import { SecurityService } from '../../services/security-service';
import { ReportParametersDialog } from "../../secure/dialogs/report-parameters-dialog";
import { ReportParametersMillContactDialog } from "../../secure/dialogs/report-parameters-mill-contact-dialog";
import { ReportParametersDialog2 } from "../../secure/dialogs/report-parameters-dialog-2";
import 'jquery';
import 'Bloodhound';
import 'typeahead';
import { RptContactsVerificationDialog } from '../../secure/dialogs/rpt-contacts-verification-dialog';
import { WebApiService } from '../../services/web-api-service';
import { SettingsService } from '../../services/settings-service';

@autoinject()
export class NavbarSecure {
    appVersion: any;
    unreadNotificationCount: number;
    constructor(
        private dialogService: DialogService,
        private loginController: LoginController,
        public securityService: SecurityService,
        public aurelia: Aurelia,
        public settingsService: SettingsService,
        public router: Router,
        private api: WebApiService) {
        this.environment = (<any>aurelia.host.attributes).environment.value;
        this.securityService.init().then(() => this.isReady = true);
        this.developmentRequestEmail = (<any>aurelia.host.attributes).developmentRequestEmail.value;
        this.appVersion = (<any>aurelia.host.attributes).version.value;
    }

    
    public developmentRequestEmail: string = "";
    public notifications = [
        // {
        //     type: 'comment',
        //     priority: 3,
        //     author: "Alisa Carlise",
        //     createdDate: '08/12/2023 3:12pm',
        //     content: 'Division is asking for status update on this.',
        //     read: true,
        //     iconClass: "fa-comment-o",
        //     navLink: '/requests/fc5e4902-c815-4706-bbf6-08609d31ac46'
        // },
        // {
        //     type: 'comment',
        //     priority: 3,
        //     author: "Emily Padgett",
        //     createdDate: '08/06/2023 11:42am',
        //     content: 'I talked to Bob and he is changing insurance carrier',
        //     read: false,
        //     iconClass: "fa-comment-o",
        //     navLink: '/tasks/89e3a3c4-aec0-498e-9756-2ff773ace5ec'
        // },
        // {
        //     type: 'info',
        //     priority: 3,
        //     author: "System",
        //     createdDate: '08/09/2023 9:23am',
        //     content: 'New tasks have been assigned to you',
        //     read: false,
        //     iconClass: "fa-info-circle",
        //     navLink: '/tasks'
        // },
        // {
        //     type: 'info',
        //     priority: 1,
        //     author: "System",
        //     createdDate: '08/25/2023 5:23am',
        //     content: 'Email subsystem is down',
        //     read: false,
        //     iconClass: "fa-exclamation-circle",
        //     navLink: ''
        // }
    ];

    async navigateNotification(item) {
        if (item.navLink) {
            this.router.navigate(item.navLink);
        }
        item.isRead = true;
        await this.api.post("notification", "UpdateNotification", item);
        this.calculateUnreadNotificationCount();
    }

    calculateUnreadNotificationCount() {
        this.unreadNotificationCount = this.notifications.filter(o => !o.isRead).length;
    }


    async toggleIsRead(item, e) {
        e.preventDefault();
        e.stopPropagation();
        item.isRead = !item.isRead;
        await this.api.post("notification", "UpdateNotification", item);
        this.calculateUnreadNotificationCount();
    }

    async removeNotification(item) {
        item.active = false;
        await this.api.post("notification", "UpdateNotification", item);
        this.notifications.splice(this.notifications.indexOf(item), 1);
        this.calculateUnreadNotificationCount();
    }

    canShowNavItem(item) {
        var itemConfig = item.config;
        var canShow = true;

        if (itemConfig.role) {
            canShow = canShow && this.securityService.hasRole(itemConfig.role);
        }
        if (itemConfig.condition) {
            canShow = canShow && eval(itemConfig.condition);
        }
        return canShow;
    }

    searchValue: string;
    isReady: boolean = false;

    prepareQueryFn(query, settings: JQueryAjaxSettings) {
        settings.url = "/api/carriers/globalsearch?keyword=" + encodeURIComponent(query);
        settings.headers = {
            'Accept': 'application/json',
            //'Authorization': this.getAuthToken()
        };
        return settings;
    }

    //user clicked on the search result
    processResult(suggestedCarrier) {
        this.router.navigate('/work-carrier/' + suggestedCarrier.id);
    }

    environment: string;

    async attached() {
        this.checkNotifications();
        setInterval(() => { this.checkNotifications() }, 30000);
    }

    public async readAll() {
        await this.api.post("notification", "readAll");
        this.checkNotifications();
    }

    public async clearAll() {
        await this.api.post("notification", "clearAll");
        this.checkNotifications();
    }

    private async checkNotifications() {
        const result = await this.api.get("notification", "getMyNotifications");
        const notifications: any[] = JSON.parse(result.response);
        notifications.forEach(o => {
            if (!this.securityService.hasRole("Edit")) {
                o.displayRecordNumber = o.ticketRecord.displayValue;
                o.navLink = `/ticket/${o.ticketRecord.value}`;
            } else {
                o.displayRecordNumber = o.targetRecord.displayValue;
                switch ((o.targetTable || "").toLowerCase()) {
                    case "request":
                        o.navLink = `/requests/${o.targetRecord.value}`;
                        break;
                    case "task":
                        o.navLink = `/tasks/${o.targetRecord.value}`;
                        break;
                    default:
                        o.navLink = undefined;
                }
            }
        });
        this.notifications = notifications;
        this.calculateUnreadNotificationCount();
    }


    logout() {
        (<any>window.location) = "/logout";
    }

    launchReport(report, defaultFileName, format) {
        if (report == "Master Approved Carriers") {
            this.dialogService.open(
                {
                    viewModel: ReportParametersDialog2,
                    model: report
                });
        } else if (report == "RptContactsVerification") {
            this.dialogService.open(
                {
                    viewModel: RptContactsVerificationDialog,
                    model: report
                });
        } else if (report == "RptCarrierContactsByMill") {
            this.dialogService.open(
                {

                    viewModel: ReportParametersMillContactDialog,
                    model: {
                        parameters: ['mill', 'contactType', 'status', 'inboundLanes', 'outboundLanes', 'equipment', 'unassignedCarriers'],
                        reportName: report,
                        format: format,
                        fileName: defaultFileName
                    }
                });
        } else if (report == "MillCarrierStatus") {
            this.dialogService.open(
                {
                    viewModel: ReportParametersMillContactDialog,
                    model: {
                        parameters: ['mill'],
                        reportName: report,
                        format: format,
                        fileName: defaultFileName
                    }
                });
        } else {
            // all reports with no parameters
            var reportFragment = encodeURIComponent(report); //this should also include any parameters (e.g. ?param1=xyz)
            window.open("/Report/Download?fileName=" + encodeURIComponent(defaultFileName) + "&reportFragment=" + reportFragment + "&format=" + format);
        }


        //        window.open("http://rzcltdevsql01.rz.nucorsteel.local/ReportServer/Pages/ReportViewer.aspx?/CarrierManagementPortal/Mill+Carrier+Status");
    }


    goToPublicLanding() {
        window.location.href = "/landing";
    }
    goToRegistration() {
        window.location.href = "/register";
    }
    changePassword() {
        this.router.navigateToRoute("change-password");
    }
}
